module.exports = __webpack_public_path__ + "img/odds-type.597404e5.svg";